export function objectKeys<T extends {}>(object: T) {
  return Object.keys(object) as Array<keyof T>
}

export function objectMap<T extends {}>(object: T): [T[keyof T], keyof T][] {
  return objectKeys(object).map(key => [object[key], key])
}
